import React from "react";
import AppLayout from "../components/app-layoout";
import { Stack, Typography, Divider, Grid, styled, Box } from "@mui/material";
import { StyledGradienthBox } from "./Properties";
import { LayoutContainer } from "../components/app-layoout/container";
import StarIcon from "../components/icons/StarIcon";
import ContactForm from "../components/Form/ContactForm";
import Office from "../components/Office";
import ExploreContact from "../components/Explore-Contact";
import AskedQuestionCarousel from "../components/PropertiesView/Question-carousel";
import useWindowSize from "../hooks/useWindowSize";
const StyledItemStack = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.main,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  padding: "15px 20px",
  gap: "15px",
}));

const Contact = () => {
  const screenWidth = useWindowSize();
  return (
    <AppLayout>
      <Stack py="70px">
        <StyledGradienthBox>
          <LayoutContainer>
            <Stack>
              <Typography variant="h2" color="text.secondary" mb={2}>
                Póngase en contacto con Plusval Estate
              </Typography>

              <Typography
                variant="subtitle1"
                color="text.primary"
                width={{ xs: "100%", md: "70%" }}
              >
                Bienvenido a la página de contacto de Plusval Estate. Estamos
                aquí para ayudarle con cualquier consulta, solicitud o
                comentario que pueda tener. Si busca comprar o vender una
                propiedad, explorar oportunidades de inversión o simplemente
                quiere contactarnos, estamos a solo un mensaje. Contáctenos y
                conversemos.
              </Typography>
            </Stack>
          </LayoutContainer>
        </StyledGradienthBox>
        <Divider variant="fullWidth" orientation="horizontal" />
        <Grid container spacing={2} p={2} justifyContent={"center"}>
          {contactData.map((item, i) => (
            <Grid
              item
              key={i}
              xs={screenWidth < 700 ? 12 : 6}
              md={6}
              lg={3}
              xl={3}
            >
              <StyledItemStack direction="column" alignItems="center">
                <Box
                  component="img"
                  src={item.icon}
                  width={{ xs: "40px", md: "65px" }}
                  height={{ xs: "40px", md: "65px" }}
                />
                {item?.txt ? (
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    align="center"
                  >
                    {item.txt}
                  </Typography>
                ) : null}
                {item?.link ? (
                  <Stack direction="row" alignItems="center" gap={1}>
                    {item?.link.map((socil, index) => (
                      <Typography
                        key={index}
                        variant="subtitle1"
                        color="text.secondary"
                        align="center"
                      >
                        {socil.socilName}
                      </Typography>
                    ))}
                  </Stack>
                ) : null}
              </StyledItemStack>
            </Grid>
          ))}
        </Grid>
        <Divider variant="fullWidth" orientation="horizontal" />
      </Stack>
      <LayoutContainer>
        <Stack mb={3}>
          <Box mb={2}>
            <StarIcon />
          </Box>
          <Typography variant="h3" color="text.secondary" mb={2}>
            Vamos a conectarnos
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.primary"
            width={{ xs: "100%", md: "60%" }}
            mb={5}
          >
            Nos entusiasma conectar con usted y conocer mejor sus objetivos
            inmobiliarios. Utilice el formulario a continuación para contactar
            con Plusval Estate. Ya sea un cliente potencial, un socio o
            simplemente tenga curiosidad sobre nuestros servicios, estamos aquí
            para responder a sus preguntas y brindarle la asistencia que
            necesita.
          </Typography>
        </Stack>
        <ContactForm />
      </LayoutContainer>
    </AppLayout>
  );
};

export default Contact;

const contactData = [
  {
    icon: "/assets/mail.svg",
    txt: "registro@plusvalestate.com",
  },
  {
    icon: "/assets/phone.svg",
    txt: "624 174 8200",
  },
  {
    icon: "/assets/location.svg",
    txt: "Av. Hidalgo 2430. Guadalajara, 44690",
  },
];
